import UserSvg from 'assets/user.svg'
import { clsx } from 'clsx'
import { IconButton } from 'component/Button/IconButton'
import { Sticker } from 'component/Glass'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'
import css from './ProfileButton.module.scss'

type Props = {
  it: ProfileStore | undefined
  inline?: boolean
}

export const ProfileButton = observer(({ it, inline }: Props) => {
  const id = it?.identity_id
  const active =
    it && it.identity_id === store.profile.identity_id
  const picture = it?.picture
  const created = store.identities.profiles.reduce((r, it) => r + (it.identity_id ? 1 : 0), 0)
  const canDelete = !!it && created > 1

  const onSelect = useLatestCallback(() => {
    if (it === undefined) {
      controller.openCreateProfile()
    } else {
      controller.selectProfile(it)
    }
  })

  const onDelete = useLatestCallback(() => {
    if (it) controller.deleteProfile(it)
  })

  const onEdit = useLatestCallback(() => {
    controller.selectProfile(it)
    controller.editProfile()
  })

  const photoClass = it?.type === 'full' ? css.photo : undefined

  function icon() {
    if (picture) return <Image src={picture} className={photoClass} />
    if (id) return null
    if (it) return <UserSvg width={24} height={24} />
    return (
      <Space className={css.dash} center>
        <Icon name="add" size={24} />
      </Space>
    )
  }

  return (
    <Space className={css.button} center>
      <Space
        className={clsx(css.circle, active && css.selected)}
        oh
        onClick={onSelect}
      >
        <Space className={css.inner} center>
          {icon()}
        </Space>
      </Space>
      <Sticker circle pin={[-12, -12, null, null]}>
        {!inline && canDelete && (
          <IconButton small action={onDelete}>
            <Icon name="delete" />
          </IconButton>
        )}
        {inline && it && (
          <IconButton small action={onEdit}>
            <Icon name="edit" />
          </IconButton>
        )}
      </Sticker>
    </Space>
  )
})
